import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import WebFont from "webfontloader";
import { AuthProvider } from "./context/AuthContext";
import { BetSlipProvider } from "./context/BetSlipContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
WebFont.load({
  google: {
    families: ["Inter", "Lato", "Ubuntu"],
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 min - data fresh, no refetch
      gcTime: 5 * 60 * 1000, // 5 min - cache kept
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <>
  <ToastContainer position="top-right" autoClose={2000} draggable />
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
  </>
  // </React.StrictMode>
);